<template>
  <div style="position: relative">
    <section class="box-gray-plans">
    </section>
    <div class="container mt-30 mb-100-custom">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <h2 class="text-align-center-custom">{{ $t('plans.title') }}</h2>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              {{ $t('plans.free') }}
            </div>
            <div class="card-body">
              <h5 class="card-title text-align-center-custom mt-4">$0</h5>
              <p class="text-align-center-custom">{{ $t('plans.year') }}</p>
              <div class="d-flex justify-content-custom mt-4">
                <hr class="line-card">
              </div>
              <div class="d-flex justify-content-custom">
                <ul class="list-unstyled mt-3 mb-4 custom-list">
                  <li>{{ $t('plans.planFree.gallery') }}</li>
                  <li>{{ $t('plans.planFree.category') }}</li>
                  <li>{{ $t('plans.planFree.photos') }}</li>
                </ul>
              </div>
              <div class="d-flex justify-content-custom margin-card">
                <router-link :to="{ name: 'Register' }">
                  <button type="button" class="btn btn-lg btn-block btn-outline-primary">{{
                      $t('plans.button')
                    }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card">
            <div class="card-header card-header-center">
              {{ $t('plans.pro') }}
            </div>
            <div class="card-body bg-primary-color"
                 style="border-bottom-left-radius: 25px;border-bottom-right-radius: 25px">
              <div class="d-flex justify-content-custom mt-4">
                <img src="../../images/landing/logo/logo_plans.png" class="logo-chuspic"/>
              </div>
              <h5 class="card-title text-white-custom text-align-center-custom mt-4">$10,000</h5>
              <p class="text-align-center-custom text-white-custom">{{ $t('plans.year') }}</p>
              <div class="d-flex justify-content-custom mt-4">
                <hr class="line-card bg-white-custom">
              </div>
              <div class="d-flex justify-content-custom">
                <ul class="list-unstyled mt-3 mb-4 custom-list text-white-custom">
                  <li>{{ $t('plans.planPro.gallery') }}</li>
                  <li>{{ $t('plans.planPro.category') }}</li>
                  <li>{{ $t('plans.planPro.photos') }}</li>
                  <li>{{ $t('plans.planPro.recognition') }}</li>
                  <li>{{ $t('plans.planPro.web') }}</li>
                  <li>{{ $t('plans.planPro.sales') }}</li>
                </ul>
              </div>

              <div class="d-flex justify-content-custom margin-card">
                <router-link :to="{ name: 'Register' }">
                  <button type="button" class="btn btn-lg btn-block btn-outline-primary btn-pro">
                    {{ $t('plans.button') }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              {{ $t('plans.basic') }}
            </div>
            <div class="card-body">
              <h5 class="card-title text-align-center-custom mt-4">$XXXXX</h5>
              <p class="text-align-center-custom">{{ $t('plans.year') }}</p>
              <div class="d-flex justify-content-custom mt-4">
                <hr class="line-card">
              </div>
              <div class="d-flex justify-content-custom">
                <ul class="list-unstyled mt-3 mb-4 custom-list">
                  <li>{{ $t('plans.planBasic.gallery') }}</li>
                  <li>{{ $t('plans.planBasic.category') }}</li>
                  <li>{{ $t('plans.planBasic.photos') }}</li>
                  <li>{{ $t('plans.planBasic.sales') }}</li>
                </ul>
              </div>

              <div class="d-flex justify-content-custom margin-card">
                <router-link :to="{ name: 'Register' }">
                  <button type="button" class="btn btn-lg btn-block btn-outline-primary">{{ $t('plans.button') }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../../components/Loader"
import Register from "../../models/Register"
import InputForm from "../../components/InputForm.vue";

export default {
  name: "Plans",
  components: {
    InputForm,
    Loader
  },
  data() {
    return {}
  },

}
</script>


<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/landing/main';


.card {
  position: relative;
  z-index: 2;
  margin-top: 20px;
  border-radius: 20px !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.card-header {
  border-top-left-radius: 25px !important;
  padding: 13px;
  border-top-right-radius: 25px !important;
  background-color: #005466;
  color: white;
  text-align: center;
  font-weight: bold;
}

.card-header-center {
  background-color: #00D1FF !important;
  color: #005466 !important;
  text-align: center;
}

.margin-card {
  margin-top: 50px;
  margin-bottom: 30px;
}

.card-title {
  font-size: 1.9rem;
  font-weight: bold;
}

.btn-primary, .btn-outline-primary {
  color: #fff;
  font-weight: bold !important;
  font-size: 17px !important;
  border-color: #005466 !important;
}

.btn-pro {
  background: white !important;
  color: #005466 !important;
}

.btn-outline-primary {
  color: #005466 !important;
  background-color: transparent;
}


.btn-primary:hover, .btn-outline-primary:hover {
  background-color: #005466 !important;
  border-color: #005466 !important;
  color: white !important;
}

.line-card {
  width: 177px;
}

.custom-list li {
  list-style-type: disc;
}

.box-gray-plans {
  position: absolute;
  top: 30%;
  z-index: 1;
  clip-path: polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%);
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: #ededed;
}
</style>
